import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appLicensePlateMask]'
})
export class LicensePlateMaskDirective {

  constructor(
    private model: NgControl
  ) { }

  @HostListener('ngModelChange') ngModelChange() {
    this.modelValue();
  }

  @HostListener('keydown.backspace') onKeyDownBackspace() {
    this.modelValue(true);
  }

  private modelValue(backspace?: boolean) {
    if (this.model) {
      var model: any = this.model;
      if(model.viewModel) {
        if (typeof model.viewModel === 'number') {
          model.viewModel = model.viewModel.toString();
        }
        this.inputChange(model.viewModel, backspace);
      }
    }
  }

  private inputChange(model: any, backspace?: any) {
    if (model) {
      var newVal = model;

      if (backspace) {
        if(newVal.length === 2){
          newVal = newVal.substring(0, newVal.length - 1);
        }
      }

      if (newVal.length == 0) {
        newVal = '';
      } else if(newVal.length <= 3) {
        newVal = this.testWord(newVal);
        newVal = newVal.toUpperCase();
      } else if(newVal.length <= 8) {
        newVal.replace('-', '');
        var x1: string = newVal.slice(0, 3);
        var x2: string = newVal.slice(3, newVal.length);
        x1 = this.testWord(x1);
        x2 = this.testNumber(x2);
        newVal = x1.concat(x2);
        newVal = newVal.replace(/(\w{0,3})(\d{0,4})/, "$1-$2");
      }

      this.model.valueAccessor.writeValue(newVal);
    }
  }

  private testWord(word: string) {
    word = word.replace(/[^a-zA-Z]+/, '');
    word = word.replace(/(\w{0,3})/, "$1");
    return word;
  }

  private testNumber(numb: string) {
    numb = numb.replace(/\D/g, '');
    numb = numb.replace(/(\d{0,4})/, "$1");
    return numb;
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/license-plate-mask.directive.ts
 **/